import type { Activity } from "@/entities/activity";

import { getModelKey } from "@/modules/model";

// TODO DEV-8365 delete helper when class path will be replaced by model slug
export const getActivitySubjectModel = (activity?: Activity) => {
  return getModelKey(activity?.subject_type);
};

// TODO DEV-8365 delete helper when class path will be replaced by model slug
export const getActivityCauserModel = (activity?: Activity) => {
  return getModelKey(activity?.causer_type ?? undefined);
};

export const getActivityRequestedBy = (activity?: Activity) => {
  const { requested_for, requested_version } = activity?.properties ?? {};

  return requested_for ? `${requested_for} ${requested_version ?? ""}` : "-";
};

export const getActivityBatchUUID = (activity?: Activity) => {
  return activity?.properties && "batch_uuid" in activity.properties
    ? activity.properties.batch_uuid
    : undefined;
};

export const isBatchActivity = (activity?: Activity) => {
  const batchUUID = getActivityBatchUUID(activity);

  return !!batchUUID;
};

export const getActivityGroupedIds = (activity?: Activity) => {
  return activity?.properties && "grouped_ids" in activity.properties
    ? activity.properties.grouped_ids
    : undefined;
};
